import React from "react";
import { Route, Routes } from "react-router-dom";
import Prompt from "./component/Prompt/Prompt";
import StockProvider from "./contexts/StockContext";
import {
  AddUser, ApiKey, Layout, ListUser, LoginForm,
  PageNotFound, Payment, PromptList, ResetPassword
} from "./Pages";
import SubscriptionPlanList from "./Pages/SubscriptionPlanList/SubscriptionPlanList";
import AddPlans from "./Pages/SubscriptionPlans/Add/AddPlans";
import EditPlans from "./Pages/SubscriptionPlans/Edit/EditPlans";

import AddCompany from "./Pages/Company/Add/AddCompany";
import Company from "./Pages/Company/Company";
import Addportfolio from "./Pages/PortFolio/AddPortfolio";
import Portfolio from "./Pages/PortFolio/PortFolio";
import UpdateForm from "./Pages/PortFolio/UpdateForm";
import Proposal from "./Pages/Proposal/Proposal";
import ProposalList from "./Pages/ProposalList/ProposalList";
import Companies from "./Pages/SuperAdmin/Companies/Companies";
import Users from "./Pages/SuperAdmin/Users/Users";
import TechStack from "./Pages/TechStack/TechStack";
import Feedback from "./Pages/feedback/feedback";
import FeedbackList from "./Pages/feedbackList";
function App() {
  return (
    <StockProvider>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Proposal />} />
          <Route path="users/add" element={<AddUser />} />
          <Route path="users/" element={<ListUser />} />
          <Route path="apikey/" element={<ApiKey />} />
          <Route path="prompt" element={<Prompt />} />
          <Route path="promptlist/" element={<PromptList />} />
          {/* <Route path="plans" element={<SubscriptionPlans />} /> */}
          <Route path="plan-list" element={<SubscriptionPlanList />} />
          <Route path="plans/add" element={<AddPlans />} />
          <Route path="plans/edit/:id" element={<EditPlans />} />
          <Route path="prompt" element={<Prompt />} />
          <Route path="payment" element={<Payment />} />
          <Route path="proposalform" element={<Proposal />} />
          <Route path="proposal-list" element={<ProposalList />} />
          <Route path="portfolio" element={<Portfolio />} />
          <Route path="addportfolio" element={<Addportfolio />} />
          <Route path="portfolio/update/:id" element={<UpdateForm />} />
          <Route path="list/company" element={<Company />} />
          <Route path="/superadmin/companies" element={<Companies />} />
          <Route path="/superadmin/users" element={<Users />} />
          <Route path="/techstack" element={<TechStack />} />
          <Route path="/Feedback" element={<Feedback />} />
          <Route path="/FeedbackList" element={<FeedbackList />} />
        </Route>
        <Route path="login" element={<LoginForm />} />
        <Route path="passwordReset/:token/:id" element={<ResetPassword />} />
        <Route path="/add/company" element={<AddCompany />} />
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </StockProvider>
  );
}

export default App;
